import { createClient } from "@supabase/supabase-js";
import { AssetType } from "types/asset";

export const supabase = createClient(
  process.env.REACT_APP_SUPABASE_URL as string,
  process.env.REACT_APP_SUPABASE_API_KEY as string
);

export const addFileToAssetsTable = (path: string, assetType: AssetType) => {
  return supabase.storage
    .from(assetType)
    .createSignedUrl(path, 864000000)
    .then((res) => {
      const signedUrl = res.data?.signedUrl;
      if (signedUrl) {
        return supabase.from("assets").insert({ type: assetType, url: signedUrl });
      }
    });
};

export const uploadFile = (bucket: string, file: File) => {
  return supabase.storage
    .from(bucket)
    .upload(`${Date.now()}.${file.name.split(".").pop()}`, file, {
      cacheControl: "3600",
      upsert: false,
    })
    .then((res) => {
      const path = res.data?.path;
      if (path) {
        return path;
      } else {
        return null;
      }
    })
    .then((path) => {
      if (path) {
        return supabase.storage
          .from(bucket)
          .createSignedUrl(path, 864000000)
          .then((res) => res.data?.signedUrl);
      } else {
        return undefined;
      }
    });
};
